import type { TabData } from '../types/Tabs'

export const findTabIndexById = (data: TabData[], id: string) =>
	data.findIndex((item) => item.id === id)
